export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
              手机网页即开即看
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed font-label max-w-lg mx-auto lg:mx-0">
              嫩草视频专为手机浏览器优化，无需下载APP。在任何手机浏览器中输入网址即可畅享<strong className="text-foreground-900 font-semibold">97视频</strong>、<strong className="text-foreground-900 font-semibold">丝瓜视频</strong>等高清影视资源，流畅不卡顿，随时随地追剧观影。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-primary-50 text-primary-700 font-label text-sm">
                <i className="ri-smartphone-line"></i>
                <span>手机浏览器访问</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-accent-50 text-accent-700 font-label text-sm">
                <i className="ri-speed-up-line"></i>
                <span>即开即看免下载</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-secondary-50 text-secondary-700 font-label text-sm">
                <i className="ri-hd-line"></i>
                <span>高清流畅播放</span>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-sm lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-3 bg-primary-500/10 rounded-3xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20video%20streaming%20interface%20with%20movie%20thumbnails%20grid%2C%20warm%20coral%20and%20amber%20UI%20accents%2C%20glossy%20screen%2C%20minimal%20device%20frame%2C%20clean%20presentation%2C%20product%20showcase%20style%2C%20no%20visible%20brand%20logos&width=600&height=800&seq=app-nc-01&orientation=portrait"
                alt="嫩草视频手机网页版界面展示"
                className="relative w-full rounded-2xl object-cover"
                style={{ aspectRatio: '3/4' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}